module.exports = __webpack_public_path__ + "img/guide-add-recipe.c11d17d5.gif";